import { useRef, useState, useLayoutEffect } from 'react'

const paddings = 2 * 20
const verticalUsedSpace = 165
const multiplier = 0.8

const useImgMaxHeight = () => {
  const ref = useRef<HTMLDivElement>(null)

  const [imgMaxHeight, setImgMaxHeight] = useState<number>(0)

  useLayoutEffect(() => {
    const compute = () => {
      const windowHeight = window.innerHeight
      const modalMaxHeight = windowHeight * multiplier - paddings
      const nextMaxHeight = Math.max(0, modalMaxHeight - verticalUsedSpace)
      setImgMaxHeight(nextMaxHeight)
    }

    compute()
    window.addEventListener('resize', compute)
    return () => window.removeEventListener('resize', compute)
  }, [])

  return [ref, imgMaxHeight] as const
}

export default useImgMaxHeight
